import React, { useState, useRef, useEffect } from "react";
import CommonInputContainer from "./CommonInputContainer";

function CommonDropdownInput({
  options = [],
  value,
  placeholder,
  onChange,
  label,
  error,
  className,
  optionObject,
  dropdownPosition,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    handleToggle();
    if (onChange) {
      onChange(value);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <CommonInputContainer
      label={label}
      className={className}
      error={error && !value}
    >
      <div ref={dropdownRef} className="relative w-full">
        <div
          onClick={handleToggle}
          onMouseDown={(event) => event.preventDefault()}
          className={`w-full h-12 items-center px-4 border ${
            error && !value ? "border-red-600" : "border-[#DBDBDB]"
          } bg-white rounded-lg placeholder:text-[#A4B1C1] focus:outline-none flex justify-between cursor-pointer`}
        >
          <span className={`${value ? "text-black" : "text-[#A4B1C1]"}`}>
            {(optionObject
              ? options.find((item) => item.code === value)?.label
              : value) || placeholder}
          </span>
          <img
            src="/IconChevronDown.svg"
            alt=""
            className={`w-3 transition-all object-contain ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </div>
        {isOpen && (
          <ul
            className={
              "absolute w-full mt-2 bg-white border border-[#DBDBDB] rounded-lg shadow-md z-10" +
              " " +
              dropdownPosition
            }
          >
            {optionObject ? (
              <>
                {options?.map((option, index) => (
                  <li
                    key={index}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => handleOptionClick(option?.code)}
                    className="px-4 py-2 hover:bg-[#F0F4F8] cursor-pointer whitespace-normal"
                  >
                    {option?.label}
                  </li>
                ))}
              </>
            ) : (
              <>
                {options?.map((option, index) => (
                  <li
                    key={index}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => handleOptionClick(option)}
                    className="px-4 py-2 hover:bg-[#F0F4F8] cursor-pointer whitespace-normal"
                  >
                    {option}
                  </li>
                ))}
              </>
            )}
          </ul>
        )}
      </div>
    </CommonInputContainer>
  );
}

export default CommonDropdownInput;
